var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"ButtonSwitch",class:{
    'ButtonSwitch--active': _vm.inputIsActive,
  },attrs:{"disabled":_vm.isDisabled,"type":"button"},on:{"click":_vm.toggle}},[_c('span',{staticClass:"ButtonSwitch__line"},[_c('span',{staticClass:"transition ButtonSwitch__circle",class:{
        'bg-theme-switch-button-circle': !_vm.inputIsActive,
        'bg-blue': _vm.inputIsActive,
      }})])])}
var staticRenderFns = []

export { render, staticRenderFns }